import { render, staticRenderFns } from "./ManualAssignment.vue?vue&type=template&id=f54cfad8"
import script from "./ManualAssignment.vue?vue&type=script&lang=js"
export * from "./ManualAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports